<template>
  <div class="fotoWrap">
    <div class="fotoWrapFinput">
      <p>{{title}}</p>
      <p id="importantId" class="errorMsg" v-show="showErrorMessage.length > 0">{{showErrorMessage}}</p>
      <div class="fotoWrap_cssKostil" v-if="imageData.length === 0">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.71 5.71L9 3.41V13a1 1 0 102 0V3.41l2.29 2.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-4-4a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21l-4 4a1.004 1.004 0 101.42 1.42zM19 10a1 1 0 00-1 1v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6a1 1 0 10-2 0v6a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1z" fill="#43AC35"/></svg>
        <p>Нажмите и выберите файл или перетащите изображение в область</p>
      </div>
      <div v-else>
        <img :src="imageData" alt="">
      </div>
      <input type=file v-on:change="previewImage" :id="target" accept="image/*" >
    </div>
    <div class="fotoWrapDesc">
      <p>Пример фотографии:</p>
      <img :src="photoSample" alt="">
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "imageInput",
    props:{
      photoSample: {
        type: String,
        default: require('@/assets/images/Passport-vector-350x500.jpg')
      },
      target:{
        type: String,
        default: ''
      },
      title:{
        type: String,
        default: 'Загрузите главный разворот Вашего паспорта.'
      },
      errorMsg:{
        type: String,
        default: ''
      },
      // capture:{
      //   type: String,
      //   default: ''
      // }
    },
    data: function () {
      return {
        imageData: '',
      }
    },
    methods: {
      previewImage: function (event) {
        // Reference to the DOM input element
        this.imageData = '';
        let input = event.target;
        // let self = this;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          let reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            if(e.target.result.includes('data:image')) {
              this.imageData = e.target.result;
              this.$emit('imageData',{value:this.imageData,target: this.target});
              this.$store.dispatch('errorShow', {
                target: 'smartIdFileID',
                value: false,
              });
            }
          };
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
        }
      }
    },
    computed: {
      ...mapState({
        statusVuex: state => state.Form.workData.smartIdFileID
      }),
      showErrorMessage() {
        return (this.errorMsg.length > 0) ? this.errorMsg : (this.statusVuex.ShowError) ? this.statusVuex.msg : '';
      },
    }
  }
</script>

<style scoped>
    input{position: absolute;top:0;left:0;width: 100%;height: 100%;opacity: 0;}
    button{pointer-events: none}
    .fotoWrap{position: relative;background: #0d5a44;padding: 5vw;color:white;}
    .fotoWrap_cssKostil{display: flex;align-items: center;justify-content: space-evenly;border: 2px dashed #43AC35;flex-direction: column;text-align: center;}
    .fotoWrap_cssKostil > p{margin:  5vw 0;}
    .fotoWrap_cssKostil > svg{width: 10vw;height: auto;margin:  5vw 0;}
    .fotoWrapFinput > p{text-align: center;margin-bottom: 5vw;}
    .fotoWrapFinput img{width: 100%;height: auto}
    .fotoWrapDesc > p{text-align: center;margin: 5vw 0;}
    .fotoWrapDesc img{width: 100%}


    @media screen and (min-width: 760px) {
      .fotoWrapFinput > p{text-align: left;margin-bottom: 0vw;}
      .fotoWrap > div{  font-size: 1.6vw;}
      .fotoWrap{display: flex;padding: 2vw;justify-content: space-between}
      .fotoWrap_cssKostil {height: 70%}
      .fotoWrap_cssKostil > svg{width: 5vw;height: auto;margin:  2vw 0;}
      .fotoWrap_cssKostil > p{margin:  2vw 0;}
      .fotoWrapFinput{width: 65%}
      .fotoWrapDesc{display: flex;justify-content: space-between;flex-direction: column;width: 29%}
      .fotoWrapFinput img{width: auto;height: 24vw;}
      .fotoWrapDesc img{width: 100%;height: auto}
      .fotoWrapDesc p{width: 100%;margin-bottom: 2vw;}
      .fotoWrapFinput{display: flex;flex-direction: column;justify-content: space-between}
      .fotoWrapDesc > p{text-align: center;margin: 0 0 2vw 0;}
    }
    @media screen and (min-width: 1140px) {
      .fotoWrap{margin-bottom: 25px}
      .fotoWrap > div{font-size: 16px;}
      .fotoWrapFinput img{width: auto;max-height: 260px;max-width: 100%}
      .fotoWrapDesc p{width: 100%;margin-bottom: 10px;}

      .fotoWrap_cssKostil > svg{margin:  10px 0;}
      .fotoWrap_cssKostil > p{margin:  10px 0;}


      #importantId{position: relative;top: 0;left: 0;background: transparent;font-size: 20px;}
    }
</style>
